import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// State
import orderApi from '../../state/modules/order/api';
import { fetchProfile } from '../../state/modules/user/actions';

export default function useCancelOrderModal(props) {
  const { order_id, onSuccessCallback, onClose } = props;

  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.user.isAuthenticated);
  const [currentReason, setCurrentReason] = useState('');
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [reasons, setReasons] = useState([]);

  const onCurrentReasonChange = useCallback(reason => {
    setCurrentReason(reason);
  }, []);

  const onToggle = useCallback(() => {
    setIsToggleOpen(prev => !prev);
  }, []);

  const onOkeyClick = useCallback(() => {
    onClose();
  }, []);

  const onAccept = useCallback(() => {
    setIsLoading(true);
    orderApi
      .cancelOrder({ order_id, comment: currentReason })
      .then(() => {
        setIsCancelled(true);

        onSuccessCallback();

        // чтобы подтянуть вернувшиеся баллы и тд и тп
        if (isAuthenticated) {
          dispatch(fetchProfile());
        }
      })
      .catch(() => false)
      .finally(() => {
        setIsLoading(false);
      });
  }, [order_id, currentReason]);

  useEffect(() => {
    orderApi
      .getCancelShortcuts()
      .then(data => {
        setReasons(data);
      })
      .then(() => false);
  }, []);

  return {
    reasons,
    currentReason,
    isToggleOpen,
    isLoading,
    isCancelled,
    onAccept,
    onCurrentReasonChange,
    onToggle,
    onOkeyClick,
  };
}
